import { BaseRepository } from "../../../../infrastructure/BaseRepository";

export class StickerCommentRepository extends BaseRepository {
  public markCommentsAsRead() {
    return this.resource('set_read')
      .create();
  }
}